import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

import { Image } from '../../atoms'
import { EquipmentCategoryEnum } from '../../../lib/graphql'

export interface IHouseEquipment {
  icon: string
  label: string
  equipmentId: string
  category: EquipmentCategoryEnum
}
export function HouseEquipment({
  className,
  equipment,
  withSeparator,
}: {
  className?: string
  equipment: IHouseEquipment
  withSeparator: boolean
}) {
  return (
    <div className={clsx(s.equipmentContent, className, s.truncate)}>
      {withSeparator ? '|' : null}

      <div className={s.containerIcon}>
        <Image type='contain' src={equipment.icon} alt={equipment.label} />
      </div>

      <span className={s.label}>{equipment.label}</span>
    </div>
  )
}
